/*
  The OnHand logo's geometry, exactly as the brand's own files draw it.

  Rebrand step 2, 17 September 2026. **This is not a redrawing.** Every value
  below is copied from docs/brand/assets/logo/, and
  src/components/brand/logoArt.test.js reads those files and fails if a single
  one of them differs. The brand guide's section 3.2 gives the same numbers.

  Why the shapes are held here rather than shown as the files themselves: the
  logo moves (guide section 3.7). The box draws in, the item drops, the letters
  rise, and a picture file cannot be asked to do any of that. So the component
  draws the same shapes inline, from these, and animates the parts.

  The colour rule (guide 3.3): the box always matches "On", the item always
  matches "Hand". Box and "On" are MedEx blue on light and white on dark; the
  item and "Hand" are MedEx gold on both.
*/

// The icon, in its 64 by 64 grid.
export const ICON_VIEWBOX = '0 0 64 64';
export const BOX_PATH = 'M8 17L12 26V44A8 8 0 0 0 20 52H44A8 8 0 0 0 52 44V26L56 17M12 26H52';
export const ITEM = { x: 20, y: 10, width: 24, height: 24, rx: 4.5, transform: 'rotate(-8 32 22)' };
// Only the part of the item above the box's front edge shows.
export const ITEM_CLIP = { x: -20, y: -80, width: 104, height: 100 };
export const STROKE = 8;

// The wordmark, "On" and "Hand", drawn from the same stroke.
export const ON_RECT = { x: 4, y: 24, width: 34, height: 32, rx: 10 };
export const ON_PATH = 'M53 34V56M53 45A11 11 0 0 1 75 45V56';
export const HAND_PATHS = ['M92 24V56M118 24V56M92 40H118', 'M157 34V56', 'M173 34V56M173 45A11 11 0 0 1 195 45V56', 'M233 24V56'];
export const HAND_CIRCLES = [{ cx: 146, cy: 45, r: 11 }, { cx: 222, cy: 45, r: 11 }];

// The two lockups.
export const HORIZONTAL = { viewBox: '-4 12 312 54', w: 312, h: 54, icon: 'translate(-3.6 9.6) scale(0.9)', word: 'translate(64 0)' };
export const STACKED = { viewBox: '0 4 237 104', w: 237, h: 104, icon: 'translate(88.5 0) scale(0.9375)', word: 'translate(0 44)' };
export const WORDMARK = { viewBox: '0 18 237 44', w: 237, h: 44 };

// The colours (guide 3.3 and 4.1).
export const MEDEX_BLUE = '#0E72B8';
export const MEDEX_GOLD = '#EDAF24';
export const WHITE = '#FFFFFF';
